<template>
  <div>
    <transition name="fade">
      <slot
        v-if="profileLoaded && haveNeededField"
        name="value"
        v-bind="profile"
      />
      <a
        v-else-if="!haveNeededField && profileLoaded && !alwaysShowCta"
        class="account-information-field-cta__add"
        href="#"
        @click.prevent="$emit('open')"
      >
        <div class="account-information-field-icon icon-add-gold" />
        {{ tc('booking.add') }} {{ fieldPlaceholder ? fieldPlaceholder : fieldLabel }}
      </a>
      <div
        v-else
        class="loader"
      />
    </transition>
    <a
      v-if="alwaysShowCta"
      class="account-information-field-cta__add"
      href="#"
      @click.prevent="$emit('open')"
    >
      <div class="account-information-field-icon icon-add-gold" />
      {{ tc('booking.add') }} {{ fieldPlaceholder ? fieldPlaceholder : fieldLabel }}
    </a>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import transformPreferences from '@utils/transformPreferences'

  export default {
    name: 'ProfileFieldValue',
    props: {
      profile: {
        type: Object
      },
      neededFields: {
        type: Array,
        required: true
      },
      fieldLabel: {
        type: String,
        required: true
      },
      fieldPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      profileLoaded: Boolean,
      alwaysShowCta: Boolean,
      preference: {
        type: Object,
        required: false
      }
    },
    computed: {
      ...mapState('auth', ['user']),
      ...mapGetters('i18n', ['tc']),

      haveNeededField() {
        return this.neededFields.length === 0 || (
          this.profile
          && this.neededFields
            .map((f) => (Array.isArray(this.profile[f]) ? this.profile[f].length > 0 : !!this.profile[f]))
            .filter((f) => !!f).length > 0
        )
      }
    },
    watch: {
      user(val) {
        if (val.otherPreferences && this.preference) {
          this.createObject()
        }
      }
    },
    methods: {
      ...mapMutations('auth', ['PATCH_USER']),
      createObject() {
        // eslint-disable-next-line prefer-destructuring
        const object = transformPreferences(
          this.user.otherPreferences,
          this.preference.items
        )
        this.PATCH_USER({ [this.preference.name]: object })
      }
    }
  }
</script>
